export var DateRangePickerSubject;
(function (DateRangePickerSubject) {
    DateRangePickerSubject["StartDateInput"] = "date-range-picker-start-date-input";
    DateRangePickerSubject["EndDateInput"] = "date-range-picker-end-date-input";
    DateRangePickerSubject["EndDateNowButton"] = "date-range-picker-end-date-now-button";
    DateRangePickerSubject["FormInput"] = "date-range-picker-form-input";
    DateRangePickerSubject["Popup"] = "date-range-picker-popup";
    DateRangePickerSubject["QuickTab"] = "date-range-picker-quick-tab";
    DateRangePickerSubject["QuickOptionPrefix"] = "date-range-picker-quick-option";
    DateRangePickerSubject["AbsoluteTab"] = "date-range-picker-absolute-tab";
    DateRangePickerSubject["AbsoluteTabApplyButton"] = "date-range-picker-absolute-tab-apply-button";
    DateRangePickerSubject["SecondaryLabel"] = "date-range-picker-secondary-label";
})(DateRangePickerSubject || (DateRangePickerSubject = {}));
//# sourceMappingURL=date-range-picker.js.map